import React, { useRef, useState, useEffect } from 'react'
import { LogOut, Star } from 'react-feather'
import { Link } from 'react-router-dom'
import useOnClickOutside from '../../../hooks/useOnClickOutside'
import NavbarFromSidebar from '../navbar'
import { ProfileAvatar, User15, logopcp } from '../../imagepath'
import { useAuth } from '../../../usercontext'
import { getCompanyLogo } from '../../../lib/company'

// eslint-disable-next-line react/prop-types
export function AdminHeader({ activeMenu, mobileMenu, setMobileMenu }) {
	const [navbar, setNavbar] = useState(false)
	const [showCart, setShowCart] = useState(false)
	const [showWish, setShowWish] = useState(false)
	const [showNotification, setShowNotification] = useState(false)
	const [showProfile, setShowProfile] = useState(false)
	const { profile } = useAuth()
	const [companyLogo, setCompanyLogo] = useState('/defaultlogo.png')

	useEffect(() => {
		const fetchLogo = async () => {
			if (profile && profile.companyId) {
				const logoUrl = await getCompanyLogo(profile.companyId)
				setCompanyLogo(logoUrl)
			}
		}
		fetchLogo()

		// Listen for the custom event
		const handleLogoUpdate = (event) => {
			setCompanyLogo(event.detail.logoUrl)
		}

		window.addEventListener('logoUpdated', handleLogoUpdate)

		return () => {
			window.removeEventListener('logoUpdated', handleLogoUpdate)
		}
	}, [profile, profile?.companyId])

	// Mobile Menu toggle

	const [mobileSubMenu, setMobileSubMenu] = useState(false)

	const openMobileMenu = () => {
		document.body.classList.add('menu-opened')
		setMobileMenu(true)
		window.scrollTo({ top: 0, behavior: 'smooth' })
	}
	const hideMobileMenu = () => {
		document.body.classList.remove('menu-opened')
		setMobileMenu(false)
	}

	const openMobileSubMenu = (e) => {
		e.preventDefault()
		setMobileSubMenu(!mobileSubMenu)
	}
	const cart = useRef()
	useOnClickOutside(cart, () => setShowCart(false))

	const wish = useRef()
	useOnClickOutside(wish, () => setShowWish(false))

	const notification = useRef()
	useOnClickOutside(notification, () => setShowNotification(false))

	const profileDropdownRef = useRef()
	useOnClickOutside(profileDropdownRef, () => setShowProfile(false))

	const profileClick = (e) => {
		e.preventDefault()
		setShowProfile(!showProfile)
	}

	const changeHeaderBackground = () => {
		if (window.scrollY >= 60) {
			setNavbar(true)
		} else {
			setNavbar(false)
		}
	}
	window.addEventListener('scroll', changeHeaderBackground)

	return (
		<header className="header header-page">
			<div className="header-fixed">
				<nav
					className={navbar ? 'navbar navbar-expand-lg header-nav scroll-sticky add-header-bg' : 'navbar navbar-expand-lg header-nav scroll-sticky'}
				>
					<div className="container custom-container admin_container">
						<div className="navbar-header">
							<span id="mobile_btn" onClick={openMobileMenu} className={`${mobileMenu ? 'd-none' : 'd-block cursor_pointer'}`}>
								<span className="bar-icon">
									<span></span>
									<span></span>
									<span></span>
								</span>
							</span>
							<Link to="#" className={`navbar-brand logo ${!mobileMenu ? 'text-center' : 'text-start'}`}>
								<img
									src={companyLogo}
									className="img-fluid"
									alt="Logo"
									style={{
										maxHeight: '70px',
										width: 'auto',
										objectFit: 'contain',
										opacity: '1',
										transition: 'opacity 0.3s ease-in-out'
									}}
								/>
							</Link>
						</div>
						<NavbarFromSidebar />

						{/* Admin Menu Start */}
						<div className=" d-flex justify-content-start">
							<div className="main-menu-wrapper ">
								<ul className="nav header-navbar-rht">
									<li className="nav-item user-nav">
										<Link
											to="#"
											className={showProfile ? 'dropdown-toggle show' : 'dropdown-toggle'}
											data-bs-toggle="dropdown"
											onClick={profileClick}
										>
											<span className="user-img">
												<img src={ProfileAvatar} alt="" />
												<span className="status online"></span>
											</span>
										</Link>
										<div
											ref={profileDropdownRef}
											className={
												showProfile ? 'users dropdown-menu dropdown-menu-right show modalPosition' : 'users dropdown-menu dropdown-menu-right'
											}
											data-popper-placement="bottom-end"
										>
											<div className="user-header">
												<div className="avatar avatar-sm">
													<img src={User15} alt="User Image" className="avatar-img rounded-circle" />
												</div>
												<div className="user-text">
													<h6>Admin</h6>
												</div>
											</div>
											<Link className="dropdown-item text" to="/admin/admin-profile">
												<Star size={14} color={'#FF875A'} className="headerIcon" /> Edit Profile
											</Link>
											<Link className="dropdown-item text" to="/">
												<LogOut size={14} color={'#FF875A'} className="headerIcon" /> Logout
											</Link>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</nav>
				<div className={mobileMenu ? 'sidebar-overlay opened' : 'sidebar-overlay'}></div>
			</div>
		</header>
	)
}
